import { API_DATA_FORMAT, API_STATUS } from "core-lib/constants/network";
import { ApiDataFormat } from "core-lib/types/Network";
import { getDefaultAttributes, trackCustomGTMEvent, trackEvent } from "core-lib/utils/events";
import React from "react";
import { loginClicked } from "../constants";
import { BodyType, ResponseType, verifyOTP } from "../services/verifyOTP";
import { useAuth } from "./useAuth";

interface ApiDataType extends ApiDataFormat {
  data: null | ResponseType;
}

export type OutputType = {
  apiCall: ApiDataType;
  init: (body: BodyType) => void;
  reset: () => void;
};

type ArgType = {
  handlePostLogin?: boolean;
};

export function useVerifyOTP({ handlePostLogin = true }: ArgType): OutputType {
  const [apiCall, setApiCall] = React.useState<ApiDataType>({
    ...API_DATA_FORMAT,
  });
  const { setAuthData } = useAuth();

  async function init(body: BodyType) {
    setApiCall({ ...apiCall, apiStatus: API_STATUS.in_progress });
    const { response, error } = await verifyOTP(body);
    if (response) {
      setApiCall({ ...apiCall, apiStatus: API_STATUS.success, data: response });
      if (handlePostLogin) {
        const reqData = {
          accessToken: response?.accessToken,
          refreshToken: response?.refreshToken,
          profile: response?.profile,
          userLocations: response?.userLocations,
        };
        setAuthData(reqData);
        // Track event
        trackEvent({
          name: loginClicked.name,
          defaultAttr: getDefaultAttributes(),
          attributes: {
            [loginClicked.attributes.mode]: "phone",
            [loginClicked.attributes.mobileNumber]: body.phoneNumber,
            [loginClicked.attributes.category]: "user onboarding",
          },
        });
        if(response?.isNewUser){
          trackCustomGTMEvent({
            eventName: "pm_signup",
            attributes: { phone_number:  body.phoneNumber, },
          });
        }else{
          trackCustomGTMEvent({
            eventName: "pm_login",
            attributes: { phone_number:  body.phoneNumber, },
          });
        }
      }
    }
    if (error) {
      setApiCall({
        ...apiCall,
        apiStatus: API_STATUS.failure,
        data: null,
        apiError: error,
      });
    }
  }

  return {
    init,
    apiCall,
    reset: () => setApiCall({ ...API_DATA_FORMAT }),
  };
}
